import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { TimePickerProps } from './TimePicker.types';
import { StyledTimePicker } from './TimePicker.styles';

export const TimePicker: React.FC<TimePickerProps> = ({ time, onChange, hasError }) => {
  const [selectedTime, setSelectedTime] = useState<string>(time ? moment(time, 'hh:mm a').format('hh:mma') : '');
  const [timeOptions, setTimeOptions] = useState<string[]>([]);

  useEffect(() => {
    const generateTimeOptions = () => {
      const options: string[] = ['Select'];
      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 30) {
          const timeOption = moment().hour(hour).minute(minute).format('hh:mma');
          options.push(timeOption);
        }
      }
      return options;
    };

    setTimeOptions(generateTimeOptions());
  }, []);

  const handleTimeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    setSelectedTime(value);
    if (value !== 'Select') {
      onChange(value);
    } else {
      onChange(''); // Handle the "Select" option case
    }
  };

  return (
    <StyledTimePicker>
      <div className="custom-select-wrapper">
        <select
          className={`m-dropdown-field ${hasError ? 'error' : ''}`}
          value={selectedTime || time || ''}
          onChange={handleTimeChange}
          required
        >
          {timeOptions.map((option, index) => (
            <option
              key={index}
              value={option === 'Select' ? '' : option}
              disabled={option === 'Select'}
              hidden={option === 'Select'}
            >
              {option}
            </option>
          ))}
        </select>
      </div>
    </StyledTimePicker>
  );
};
